<template>
  <pt-sheet title="Generate Test Upload File of Employees">
    <v-form ref="form">
      <v-row>
        <v-col cols="3">
          <v-text-field
            outlined
            dense
            v-model="employeeCount"
            label="Number of Employees"
            type="number"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-btn @click="generateCSV" color="primary">Download CSV</v-btn>
    </v-form>
  </pt-sheet>
</template>

<script>
import { saveAs } from "file-saver";
import { faker } from "@faker-js/faker";
import PtSheet from "@/components/PtSheet.vue";

export default {
  name: "QATestFiles",
  components: { PtSheet },
  data: () => ({
    employeeCount: 1
  }),
  methods: {
    generateCSV() {
      const headers = [
        "SSN",
        "First Name",
        "Last Name",
        "Dob",
        "Street 1",
        "Street 2",
        "City",
        "State",
        "Zip"
      ];
      const rows = [headers];

      for (let i = 0; i < this.employeeCount; i++) {
        const ssn = this.generateSSN();
        const firstName = faker.person.firstName();
        const lastName = faker.person.lastName();
        const dob = this.generateDob();
        const street1 = faker.location.streetAddress();
        const street2 =
          Math.random() < 0.25 ? faker.location.secondaryAddress() : "";
        const city = faker.location.city();
        const state = faker.location.state({ abbreviated: true });
        const zip = faker.location.zipCode("#####");

        rows.push([
          ssn,
          firstName,
          lastName,
          dob,
          street1,
          street2,
          city,
          state,
          zip
        ]);
      }

      const csvContent = rows.map(e => e.join(",")).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "employees.csv");
    },
    generateSSN() {
      return Math.floor(100000000 + Math.random() * 900000000).toString();
    },
    generateDob() {
      const start = new Date(1930, 0, 1);
      const end = new Date(2010, 0, 1);
      const dob = new Date(
        start.getTime() + Math.random() * (end.getTime() - start.getTime())
      );
      return dob.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
